/*
 * @Date: 2022-08-23 11:40:54
 * @LastEditors: kinfai
 * @Description: 主页
 * @LastEditTime: 2022-08-31 09:06:29
 * @FilePath: \my-app\src\pages\Home\index.jsx
 */
import {useState} from "react";
import "./index.less";
import BgHeader from "../../components/BgHeader/index.jsx";
import RobetTip from "../RobetTip";
import ChatList from "../ChatList/index";
import useChatPlugin from "@/hooks/chatPlugin/index.js";
import {getPluginConfig} from "../../hooks/chatPlugin";


function Home(props) {
    const [online, setOnline] = useState(true);
    const {getPluginConfig} = useChatPlugin()
    const pluginConfig = getPluginConfig()

    // todo - api - 判断是否在线
    const isOnline = () => {
        // todo
        // setOnline
    };

    return (
        <div>
            <BgHeader/>
            {online ? <ChatList/> : <RobetTip/>}
            <div className="s-copyright">Powered by {pluginConfig.name}</div>
        </div>
    );
}

export default Home;
